import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { notification } from 'antd';

import BalanceDetailsControl from '@flp/components/balances/balance-details-control';

import IBaseComponentProps from '@components/base-component-props';
import { userLoaded } from '@store/actions';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { exception } from '@extensions/notification';

import { IUser } from '@entities/user';
import { IUserSession } from '@entities/user-session';

import { Permission, hasPermission } from '@enums/permission';
import { UserBalanceType } from '@enums/user-balance-type';

interface IBalanceDetailsProps extends IBaseComponentProps {
    userBalanceType: UserBalanceType;
}

const BalanceDetails = (props: IBalanceDetailsProps) => {
    const { serverFetch, userBalanceType } = props;

    const userSession = useAppSelector<IUserSession>((s) => s.userSession);

    const { userId } = useParams();

    const d = useAppDispatch();

    const [user, setUser] = useState<IUser>();

    const [api, contextHolder] = notification.useNotification();

    useEffect(() => {
        serverFetch(`users/${userId}`, { method: 'GET' })
            .then((data: any) => {
                setUser(data);
            })
            .catch((ex: any) => {
                exception(api, 'Ошибка получения пользователя', ex, () => d(userLoaded(undefined)));
            });
    }, []);

    return (
        <>
            {user && (
                <BalanceDetailsControl
                    userId={userId || ''}
                    userBalanceType={userBalanceType}
                    isViewMode={!hasPermission(userSession.permissions, Permission.ManageBalance)}
                    showExchangeRateInfo={true}
                    useTagRequired={!!user.tag}
                    tag={user.tag}
                    serverFetch={serverFetch}
                />
            )}
            {contextHolder}
        </>
    );
};

export default BalanceDetails;
